// Auto-generated API paths
// Do not edit manually - regenerate using generate-api-types.sh
export var API_PATHS = {
    /**
     * Path: /product-numbers/block-range
     * PUT: No description
     * Request: ProductNumberBlockRangeRequest
     * Response: ProductNumberBlockRangeResponse
     */
    PRODUCT_NUMBERS_BLOCK_RANGE: "product-numbers/block-range",
    /**
     * Path: /titles
     * GET: No description
     * Response: TitleCollectionResponse
     * POST: No description
     * Request: Title
     * Response: Title
     */
    TITLES: "titles",
    /**
     * Path: /titles/receive
     * POST: No description
     * Request: TitleMessage
     * Response: Title
     */
    TITLES_RECEIVE: "titles/receive",
    /**
     * Path: /titles/data-import/upload
     * POST: No description
     * Request: object
     * Response: void
     */
    TITLES_DATA_IMPORT_UPLOAD: "titles/data-import/upload",
    /**
     * Path: /titles/data-import/owncloud/import
     * POST: No description
     * Request: OwnCloudImportRequest
     * Response: void
     */
    TITLES_DATA_IMPORT_OWNCLOUD_IMPORT: "titles/data-import/owncloud/import",
    /**
     * Path: /thema-import/start
     * POST: No description
     * Response: object
     */
    THEMA_IMPORT_START: "thema-import/start",
    /**
     * Path: /storage/upload
     * POST: No description
     * Request: object
     * Response: StorageUploadResponseDto
     */
    STORAGE_UPLOAD: "storage/upload",
    /**
     * Path: /reports/wipo-report
     * POST: Generate WIPO Report
     * Request: WipoReportParams
     * Response: WipoReportData
     */
    REPORTS_WIPO_REPORT: "reports/wipo-report",
    /**
     * Path: /reports/sckn-report
     * POST: Generate SÄKN Report
     * Request: ScknReportParams
     * Response: ScknReportData
     */
    REPORTS_SCKN_REPORT: "reports/sckn-report",
    /**
     * Path: /reports/progress-report
     * POST: Generate Progress Report
     * Request: ProgressReportParams
     * Response: ReportResponse
     */
    REPORTS_PROGRESS_REPORT: "reports/progress-report",
    /**
     * Path: /reports/piid-report
     * POST: Generate PIID Report
     * Request: PiidExportParams
     * Response: ReportResponse
     */
    REPORTS_PIID_REPORT: "reports/piid-report",
    /**
     * Path: /reports/performance-statistics
     * POST: Generate Performance Statistics Report
     * Request: PerformanceStatisticsParams
     * Response: ReportResponse
     */
    REPORTS_PERFORMANCE_STATISTICS: "reports/performance-statistics",
    /**
     * Path: /reports/onix-export
     * POST: Generate ONIX Export
     * Request: OnixExportParams
     * Response: ReportResponse
     */
    REPORTS_ONIX_EXPORT: "reports/onix-export",
    /**
     * Path: /reports/nipos-report
     * POST: Generate NIPOS Report
     * Request: NiposReportParams
     * Response: ReportResponse
     */
    REPORTS_NIPOS_REPORT: "reports/nipos-report",
    /**
     * Path: /reports/kult-18-01
     * POST: Generate Kult 18-01 Report
     * Request: Kult1801ReportParams
     * Response: Kult1801ReportData
     */
    REPORTS_KULT_18_01: "reports/kult-18-01",
    /**
     * Path: /reports/kult-18-01/export
     * POST: Generate Kult 18-01 Report (file export)
     * Request: Kult1801ReportParams
     * Response: ReportResponse
     */
    REPORTS_KULT_18_01_EXPORT: "reports/kult-18-01/export",
    /**
     * Path: /reports/kult-15-01
     * POST: Generate Kult 15-01 Report
     * Request: Kult1501ReportParams
     * Response: Kult1501ReportData
     */
    REPORTS_KULT_15_01: "reports/kult-15-01",
    /**
     * Path: /reports/kult-15-01/export
     * POST: Generate Kult 15-01 Report (file export)
     * Request: Kult1501ReportParams
     * Response: ReportResponse
     */
    REPORTS_KULT_15_01_EXPORT: "reports/kult-15-01/export",
    /**
     * Path: /reports/ipa-report
     * POST: Generate IPA Report
     * Request: IpaReportParams
     * Response: IpaReportData
     */
    REPORTS_IPA_REPORT: "reports/ipa-report",
    /**
     * Path: /reports/identifier-report
     * POST: Generate Identifier Report
     * Request: IdentifierReportParams
     * Response: ReportResponse
     */
    REPORTS_IDENTIFIER_REPORT: "reports/identifier-report",
    /**
     * Path: /reports/annual-report
     * POST: Generate Annual Report
     * Request: AnnualReportParams
     * Response: AnnualReportData
     */
    REPORTS_ANNUAL_REPORT: "reports/annual-report",
    /**
     * Path: /publisher-prefix-ranges
     * GET: No description
     * Response: PublisherPrefixRangeCollectionResponse
     * POST: No description
     * Request: PublisherPrefixRange
     * Response: PublisherPrefixRange
     */
    PUBLISHER_PREFIX_RANGES: "publisher-prefix-ranges",
    /**
     * Path: /products
     * GET: No description
     * Response: ProductCollectionResponse
     * POST: No description
     * Request: Product
     * Response: Product
     */
    PRODUCTS: "products",
    /**
     * Path: /products/receive
     * POST: No description
     * Request: ProductMessage
     * Response: Product
     */
    PRODUCTS_RECEIVE: "products/receive",
    /**
     * Path: /products/create-with-number
     * POST: Create a product and optionally assign an ISBN/ISMN atomically
     * Request: ProductCreateWithNumberRequest
     * Response: ProductCreateWithNumberResponse
     */
    PRODUCTS_CREATE_WITH_NUMBER: "products/create-with-number",
    /**
     * Path: /product-numbers
     * GET: No description
     * Response: ProductNumberCollectionResponse
     * POST: No description
     * Request: ProductNumberCreateRequest
     * Response: ProductNumber
     */
    PRODUCT_NUMBERS: "product-numbers",
    /**
     * Path: /product-numbers/clear-selected
     * POST: No description
     * Response: ProductNumber
     */
    PRODUCT_NUMBERS_CLEAR_SELECTED: "product-numbers/clear-selected",
    /**
     * Path: /product-numbers/assign
     * POST: No description
     * Request: ProductNumberAssignRequest
     * Response: ProductNumber
     */
    PRODUCT_NUMBERS_ASSIGN: "product-numbers/assign",
    /**
     * Path: /co-edition-number-requests
     */
    CO_EDITION_NUMBER_REQUESTS: "co-edition-number-requests",
    /**
     * Path: /product-numbers/assign/preview
     * POST: No description
     * Request: ProductNumberAssignRequest
     * Response: ProductNumberAssignResponse
     */
    PRODUCT_NUMBERS_ASSIGN_PREVIEW: "product-numbers/assign/preview",
    /**
     * Path: /onix-codetables
     * GET: No description
     * Response: OnixCodetableCollectionResponse
     * POST: No description
     * Request: OnixCodetable
     * Response: OnixCodetable
     */
    ONIX_CODETABLES: "onix-codetables",
    /**
     * Path: /onix-codetable-items
     * GET: No description
     * Response: OnixCodetableItemCollectionResponse
     * POST: No description
     * Request: OnixCodetableItem
     * Response: OnixCodetableItem
     */
    ONIX_CODETABLE_ITEMS: "onix-codetable-items",
    /**
     * Path: /natural-persons
     * GET: No description
     * Response: NaturalPersonCollectionResponse
     * POST: No description
     * Request: NaturalPerson
     * Response: NaturalPerson
     */
    NATURAL_PERSONS: "natural-persons",
    /**
     * Path: /natural-persons/report-change
     * POST: No description
     * Request: NaturalPersonReportChangeRequest
     * Response: void
     */
    NATURAL_PERSONS_REPORT_CHANGE: "natural-persons/report-change",
    /**
     * Path: /legal-persons
     * GET: No description
     * Response: LegalPersonCollectionResponse
     * POST: No description
     * Request: LegalPerson
     * Response: LegalPerson
     */
    LEGAL_PERSONS: "legal-persons",
    /**
     * Path: /legal-persons/report-change
     * POST: No description
     * Request: LegalPersonReportChangeRequest
     * Response: void
     */
    LEGAL_PERSONS_REPORT_CHANGE: "legal-persons/report-change",
    /**
     * Path: /international-prefixes
     * GET: No description
     * Response: InternationalPrefixCollectionResponse
     * POST: No description
     * Request: InternationalPrefix
     * Response: InternationalPrefix
     */
    INTERNATIONAL_PREFIXES: "international-prefixes",
    /**
     * Path: /collections
     * GET: No description
     * Response: CollectionCollectionResponse
     * POST: No description
     * Request: Collection
     * Response: Collection
     */
    COLLECTIONS: "collections",
    /**
     * Path: /collections/receive
     * POST: No description
     * Request: CollectionMessage
     * Response: Collection
     */
    COLLECTIONS_RECEIVE: "collections/receive",
    /**
     * Path: /authority-import/upload
     * POST: No description
     * Request: object
     * Response: void
     */
    AUTHORITY_IMPORT_UPLOAD: "authority-import/upload",
    /**
     * Path: /authority-import/start
     * POST: No description
     * Response: object
     */
    AUTHORITY_IMPORT_START: "authority-import/start",
    /**
     * Path: /authority-import/start-from-nkp
     * POST: No description
     * Response: object
     */
    AUTHORITY_IMPORT_START_FROM_NKP: "authority-import/start-from-nkp",
    /**
     * Path: /agency/public-view/admin/reindex
     * POST: No description
     * Response: ReindexResponse
     */
    AGENCY_PUBLIC_VIEW_ADMIN_REINDEX: "agency/public-view/admin/reindex",
    /**
     * Path: /agency/inbox
     * POST: No description
     * Request: InboxEvent
     * Response: string
     */
    AGENCY_INBOX: "agency/inbox",
    /**
     * Path: /agency-publishers/find-by-product-numbers
     * POST: No description
     * Request: FindPublisherByProductNumbersRequest
     * Response: FindPublisherByProductNumbersResponse
     */
    AGENCY_PUBLISHERS_FIND_BY_PRODUCT_NUMBERS: "agency-publishers/find-by-product-numbers",
    /**
     * Path: /agency-prefixes
     * GET: No description
     * Response: AgencyPrefixCollectionResponse
     * POST: No description
     * Request: AgencyPrefix
     * Response: AgencyPrefix
     */
    AGENCY_PREFIXES: "agency-prefixes",
    /**
     * Path: /admin/sync-titles-to-legal-deposits
     * POST: No description
     * Response: TitlesSyncResultDto
     */
    ADMIN_SYNC_TITLES_TO_LEGAL_DEPOSITS: "admin/sync-titles-to-legal-deposits",
    /**
     * Path: /admin/sync-products-to-legal-deposits
     * POST: No description
     * Response: ProductsSyncResultDto
     */
    ADMIN_SYNC_PRODUCTS_TO_LEGAL_DEPOSITS: "admin/sync-products-to-legal-deposits",
    /**
     * Path: /admin/sync-persons-to-legal-deposits
     * POST: No description
     * Response: PersonsSyncResultDto
     */
    ADMIN_SYNC_PERSONS_TO_LEGAL_DEPOSITS: "admin/sync-persons-to-legal-deposits",
    /**
     * Path: /admin/sync-onix-to-legal-deposits
     * POST: No description
     * Response: OnixSyncResultDto
     */
    ADMIN_SYNC_ONIX_TO_LEGAL_DEPOSITS: "admin/sync-onix-to-legal-deposits",
    /**
     * Path: /admin/sync-collections-to-legal-deposits
     * POST: No description
     * Response: CollectionsSyncResultDto
     */
    ADMIN_SYNC_COLLECTIONS_TO_LEGAL_DEPOSITS: "admin/sync-collections-to-legal-deposits",
    /**
     * Path: /admin/obalky-knih/sync
     * POST: Start a full obalkyknih.cz cover sync
     * Response: ObalkyKnihSyncStatus
     */
    ADMIN_OBALKY_KNIH_SYNC: "admin/obalky-knih/sync",
    /**
     * Path: /admin/obalky-knih/sync/status
     * GET: Get the obalkyknih.cz cover sync status
     * Response: ObalkyKnihSyncStatus
     */
    ADMIN_OBALKY_KNIH_SYNC_STATUS: "admin/obalky-knih/sync/status",
    /**
     * Path: /admin/issn-register/status
     * GET: Get ISSN register harvest status
     * Response: IssnRegisterStatus
     */
    ADMIN_ISSN_REGISTER_STATUS: "admin/issn-register/status",
    /**
     * Path: /admin/issn-register/schedule
     * PUT: Update the ISSN register harvest schedule
     * Response: IssnRegisterSchedule
     */
    ADMIN_ISSN_REGISTER_SCHEDULE: "admin/issn-register/schedule",
    /**
     * Path: /admin/issn-register/run
     * POST: Trigger a manual ISSN register harvest
     * Response: IssnRegisterStatus
     */
    ADMIN_ISSN_REGISTER_RUN: "admin/issn-register/run",
    /**
     * Path: /admin/sync-status
     * GET: Snapshot of all bulk legal-deposits sync runs
     * Response: SyncStatusDto[]
     */
    ADMIN_SYNC_STATUS: "admin/sync-status",
    /**
     * Path: /_/tenant
     * POST: Create tenant job (create, upgrade, delete)
     * Request: tenantAttributes
     * Response: void
     */
    TENANT: "_/tenant",
    /**
     * Path: /titles/search
     * GET: No description
     * Response: TitleSearchCollectionResponse
     */
    TITLES_SEARCH: "titles/search",
    /**
     * Path: /titles/data-import/status
     * GET: No description
     * Response: TitleImportStatusDto
     */
    TITLES_DATA_IMPORT_STATUS: "titles/data-import/status",
    /**
     * Path: /titles/data-import/owncloud/files
     * GET: No description
     * Response: OwnCloudFileDtoCollection
     */
    TITLES_DATA_IMPORT_OWNCLOUD_FILES: "titles/data-import/owncloud/files",
    /**
     * Path: /titles/data-import/import-from-file
     * GET: No description
     * Response: void
     */
    TITLES_DATA_IMPORT_IMPORT_FROM_FILE: "titles/data-import/import-from-file",
    /**
     * Path: /titles/data-import/events
     * GET: No description
     * Response: CollectionResponse
     */
    TITLES_DATA_IMPORT_EVENTS: "titles/data-import/events",
    /**
     * Path: /titles/data-import/delete-file
     * GET: No description
     * Response: void
     */
    TITLES_DATA_IMPORT_DELETE_FILE: "titles/data-import/delete-file",
    /**
     * Path: /titles/data-import/active
     * GET: No description
     * Response: object
     */
    TITLES_DATA_IMPORT_ACTIVE: "titles/data-import/active",
    /**
     * Path: /thema-import/owncloud-status
     * GET: No description
     * Response: object
     */
    THEMA_IMPORT_OWNCLOUD_STATUS: "thema-import/owncloud-status",
    /**
     * Path: /thema-import/active
     * GET: No description
     * Response: object
     */
    THEMA_IMPORT_ACTIVE: "thema-import/active",
    /**
     * Path: /publisher-prefixes
     * GET: No description
     * Response: PublisherPrefixCollectionResponse
     */
    PUBLISHER_PREFIXES: "publisher-prefixes",
    /**
     * Path: /publisher-prefixes/resolve
     * GET: No description
     * Response: PublisherPrefix
     */
    PUBLISHER_PREFIXES_RESOLVE: "publisher-prefixes/resolve",
    /**
     * Path: /products/search
     * GET: No description
     * Response: ProductSearchCollectionResponse
     */
    PRODUCTS_SEARCH: "products/search",
    /**
     * Path: /products/relation-selection
     * GET: No description
     * Response: ProductCollectionResponse
     */
    PRODUCTS_RELATION_SELECTION: "products/relation-selection",
    /**
     * Path: /product-numbers/search
     * GET: No description
     * Response: ProductNumberSearchCollectionResponse
     */
    PRODUCT_NUMBERS_SEARCH: "product-numbers/search",
    /**
     * Path: /persons
     * GET: No description
     * Response: PersonCollectionResponse
     */
    PERSONS: "persons",
    /**
     * Path: /persons/search-options
     * GET: No description
     * Response: PersonSearchOption[]
     */
    PERSONS_SEARCH_OPTIONS: "persons/search-options",
    /**
     * Path: /authority-import/active
     * GET: No description
     * Response: object
     */
    AUTHORITY_IMPORT_ACTIVE: "authority-import/active",
    /**
     * Path: /agency/sync-persons
     * GET: No description
     * Response: void
     */
    AGENCY_SYNC_PERSONS: "agency/sync-persons",
    /**
     * Path: /agency/public-view/titles/sitemap
     * GET: No description
     * Response: SitemapResponseDto
     */
    AGENCY_PUBLIC_VIEW_TITLES_SITEMAP: "agency/public-view/titles/sitemap",
    /**
     * Path: /agency/public-view/titles/search
     * GET: No description
     * Response: TitleSearchResponseDto
     */
    AGENCY_PUBLIC_VIEW_TITLES_SEARCH: "agency/public-view/titles/search",
    /**
     * Path: /agency/public-view/stats
     * GET: No description
     * Response: CatalogStatsDto
     */
    AGENCY_PUBLIC_VIEW_STATS: "agency/public-view/stats",
    /**
     * Path: /agency/public-view/publishers/sitemap
     * GET: No description
     * Response: SitemapResponseDto
     */
    AGENCY_PUBLIC_VIEW_PUBLISHERS_SITEMAP: "agency/public-view/publishers/sitemap",
    /**
     * Path: /agency/public-view/publishers/search
     * GET: No description
     * Response: PublisherSearchResponseDto
     */
    AGENCY_PUBLIC_VIEW_PUBLISHERS_SEARCH: "agency/public-view/publishers/search",
    /**
     * Path: /agency/process-outbox
     * GET: No description
     * Response: void
     */
    AGENCY_PROCESS_OUTBOX: "agency/process-outbox",
    /**
     * Path: /agency/aleph-title-sync
     * GET: No description
     * Response: void
     */
    AGENCY_ALEPH_TITLE_SYNC: "agency/aleph-title-sync",
    /**
     * Path: /agency-publishers
     * GET: No description
     * Response: PublisherCollectionResponse
     */
    AGENCY_PUBLISHERS: "agency-publishers",
    /**
     * Path: /agency-publishers/unresolved
     * GET: No description
     * Response: PublisherCollectionResponse
     */
    AGENCY_PUBLISHERS_UNRESOLVED: "agency-publishers/unresolved",
    /**
     * Path: /agency-publishers/search
     * GET: No description
     * Response: PublisherSearchCollectionResponse
     */
    AGENCY_PUBLISHERS_SEARCH: "agency-publishers/search",
    /**
     * Path: /agency-publishers/search-by-prefix
     * GET: No description
     * Response: SourceIdCollectionResponse
     */
    AGENCY_PUBLISHERS_SEARCH_BY_PREFIX: "agency-publishers/search-by-prefix",
    /**
     * Path: /admin/environment-variables-agency
     * GET: No description
     * Response: EnvironmentVariableDtoCollection
     */
    ADMIN_ENVIRONMENT_VARIABLES_AGENCY: "admin/environment-variables-agency",
    /**
     * Path: /authority-import/file
     * DELETE: No description
     * Response: void
     */
    AUTHORITY_IMPORT_FILE: "authority-import/file",
};
// Parameterized path functions
/**
 * Path: /titles/{id}
 * GET: No description
 * Response: Title
 * PUT: No description
 * Request: Title
 * Response: void
 * DELETE: No description
 * Response: void
 */
export var titlesId = function (id) { return "titles/".concat(id); };
/**
 * Path: /titles/{id}/preview
 * GET: Inline record preview of a title in M21/ONIX/JSON/RDF
 * Response: string
 */
export var titlesIdPreview = function (id) { return "titles/".concat(id, "/preview"); };
/**
 * Path: /title-subjects/{id}/set-main/{titleId}
 * PUT: No description
 * Response: void
 */
export var titleSubjectsIdSetMainTitleid = function (id, titleId) { return "title-subjects/".concat(id, "/set-main/").concat(titleId); };
/**
 * Path: /publisher-prefixes/{id}
 * GET: No description
 * Response: PublisherPrefix
 * PUT: No description
 * Request: PublisherPrefix
 * Response: void
 */
export var publisherPrefixesId = function (id) {
    return "publisher-prefixes/".concat(id);
};
/**
 * Path: /publisher-prefix-ranges/{id}
 * GET: No description
 * Response: PublisherPrefixRange
 * PUT: No description
 * Request: PublisherPrefixRange
 * Response: void
 * DELETE: No description
 * Response: void
 */
export var publisherPrefixRangesId = function (id) {
    return "publisher-prefix-ranges/".concat(id);
};
/**
 * Path: /products/{id}
 * GET: No description
 * Response: Product
 * PUT: No description
 * Request: Product
 * Response: void
 * DELETE: No description
 * Response: void
 */
export var productsId = function (id) { return "products/".concat(id); };
/**
 * Path: /products/{id}/preview
 * GET: Inline record preview of a product in M21/ONIX/JSON/RDF
 * Response: string
 */
export var productsIdPreview = function (id) {
    return "products/".concat(id, "/preview");
};
/**
 * Path: /product-numbers/{productNumberId}/unblock
 * PUT: No description
 * Response: void
 */
export var productNumbersProductnumberidUnblock = function (productNumberId) { return "product-numbers/".concat(productNumberId, "/unblock"); };
/**
 * Path: /product-numbers/{productNumberId}/block
 * PUT: No description
 * Request: ProductNumberBlockRequest
 * Response: void
 */
export var productNumbersProductnumberidBlock = function (productNumberId) { return "product-numbers/".concat(productNumberId, "/block"); };
/**
 * Path: /product-numbers/{productNumberId}/assign-title
 * POST: Legalize a blocked product number by assigning an existing title to it
 * Request: ProductNumberAssignTitleRequest
 * Response: ProductNumber
 */
export var productNumbersProductnumberidAssignTitle = function (productNumberId) { return "product-numbers/".concat(productNumberId, "/assign-title"); };
/**
 * Path: /onix-codetables/{id}
 * GET: No description
 * Response: OnixCodetable
 * PUT: No description
 * Request: OnixCodetable
 * Response: void
 * DELETE: No description
 * Response: void
 */
export var onixCodetablesId = function (id) {
    return "onix-codetables/".concat(id);
};
/**
 * Path: /onix-codetable-items/{id}
 * GET: No description
 * Response: OnixCodetableItem
 * PUT: No description
 * Request: OnixCodetableItem
 * Response: void
 * DELETE: No description
 * Response: void
 */
export var onixCodetableItemsId = function (id) {
    return "onix-codetable-items/".concat(id);
};
/**
 * Path: /natural-persons/{id}
 * GET: No description
 * Response: NaturalPerson
 * PUT: No description
 * Request: NaturalPerson
 * Response: void
 * DELETE: No description
 * Response: void
 */
export var naturalPersonsId = function (id) {
    return "natural-persons/".concat(id);
};
/**
 * Path: /legal-persons/{id}
 * GET: No description
 * Response: LegalPerson
 * PUT: No description
 * Request: LegalPerson
 * Response: void
 * DELETE: No description
 * Response: void
 */
export var legalPersonsId = function (id) { return "legal-persons/".concat(id); };
/**
 * Path: /natural-persons/{id}/send-to-authority
 * POST: No description
 * Response: NaturalPerson
 */
export var naturalPersonsIdSendToAuthority = function (id) {
    return "natural-persons/".concat(id, "/send-to-authority");
};
/**
 * Path: /natural-persons/{id}/authority-id
 * PUT: No description
 * Request: AuthorityIdRequest
 * Response: NaturalPerson
 */
export var naturalPersonsIdAuthorityId = function (id) {
    return "natural-persons/".concat(id, "/authority-id");
};
/**
 * Path: /natural-persons/{id}/merge-into/{targetId}
 * POST: No description
 * Response: NaturalPerson
 */
export var naturalPersonsIdMergeIntoTargetId = function (id, targetId) { return "natural-persons/".concat(id, "/merge-into/").concat(targetId); };
/**
 * Path: /natural-persons/{id}/propose-merge/{targetId}
 * POST: No description
 * Request: PersonMergeProposalRequest
 */
export var naturalPersonsIdProposeMergeTargetId = function (id, targetId) { return "natural-persons/".concat(id, "/propose-merge/").concat(targetId); };
/**
 * Path: /natural-persons/{id}/merge-duplicates
 * POST: No description
 * Response: NaturalPerson
 */
export var naturalPersonsIdMergeDuplicates = function (id) {
    return "natural-persons/".concat(id, "/merge-duplicates");
};
/**
 * Path: /natural-persons/{id}/merge-candidates
 * GET: No description
 * Response: NaturalPersonCollectionResponse
 */
export var naturalPersonsIdMergeCandidates = function (id) {
    return "natural-persons/".concat(id, "/merge-candidates");
};
/**
 * Path: /legal-persons/{id}/send-to-authority
 * POST: No description
 * Response: LegalPerson
 */
export var legalPersonsIdSendToAuthority = function (id) {
    return "legal-persons/".concat(id, "/send-to-authority");
};
/**
 * Path: /legal-persons/{id}/authority-id
 * PUT: No description
 * Request: AuthorityIdRequest
 * Response: LegalPerson
 */
export var legalPersonsIdAuthorityId = function (id) {
    return "legal-persons/".concat(id, "/authority-id");
};
/**
 * Path: /legal-persons/{id}/merge-into/{targetId}
 * POST: No description
 * Response: LegalPerson
 */
export var legalPersonsIdMergeIntoTargetId = function (id, targetId) { return "legal-persons/".concat(id, "/merge-into/").concat(targetId); };
/**
 * Path: /legal-persons/{id}/propose-merge/{targetId}
 * POST: No description
 * Request: PersonMergeProposalRequest
 */
export var legalPersonsIdProposeMergeTargetId = function (id, targetId) { return "legal-persons/".concat(id, "/propose-merge/").concat(targetId); };
/**
 * Path: /legal-persons/{id}/merge-duplicates
 * POST: No description
 * Response: LegalPerson
 */
export var legalPersonsIdMergeDuplicates = function (id) {
    return "legal-persons/".concat(id, "/merge-duplicates");
};
/**
 * Path: /legal-persons/{id}/merge-candidates
 * GET: No description
 * Response: LegalPersonCollectionResponse
 */
export var legalPersonsIdMergeCandidates = function (id) {
    return "legal-persons/".concat(id, "/merge-candidates");
};
/**
 * Path: /natural-persons/{id}/titles
 * GET: No description
 * Response: PersonTitleCollectionResponse
 */
export var naturalPersonsIdTitles = function (id) {
    return "natural-persons/".concat(id, "/titles");
};
/**
 * Path: /legal-persons/{id}/titles
 * GET: No description
 * Response: PersonTitleCollectionResponse
 */
export var legalPersonsIdTitles = function (id) {
    return "legal-persons/".concat(id, "/titles");
};
/**
 * Path: /collections/{id}
 * GET: No description
 * Response: Collection
 * PUT: No description
 * Request: Collection
 * Response: void
 * DELETE: No description
 * Response: void
 */
export var collectionsId = function (id) { return "collections/".concat(id); };
/**
 * Path: /titles/{titleId}/aleph-sync
 * POST: No description
 * Response: object
 */
export var titlesTitleidAlephSync = function (titleId) {
    return "titles/".concat(titleId, "/aleph-sync");
};
/**
 * Path: /titles/{titleId}/aleph-sync/reset
 * POST: No description
 * Response: void
 */
export var titlesTitleidAlephSyncReset = function (titleId) {
    return "titles/".concat(titleId, "/aleph-sync/reset");
};
/**
 * Path: /publisher-prefix-ranges/{id}/open
 * POST: No description
 * Response: void
 */
export var publisherPrefixRangesIdOpen = function (id) {
    return "publisher-prefix-ranges/".concat(id, "/open");
};
/**
 * Path: /publisher-prefix-ranges/{id}/close
 * POST: No description
 * Response: void
 */
export var publisherPrefixRangesIdClose = function (id) {
    return "publisher-prefix-ranges/".concat(id, "/close");
};
/**
 * Path: /product-numbers/{productNumberId}/deselect
 * POST: No description
 * Response: void
 */
export var productNumbersProductnumberidDeselect = function (productNumberId) { return "product-numbers/".concat(productNumberId, "/deselect"); };
/**
 * Path: /international-prefixes/{id}/default
 * POST: No description
 * Response: AgencyPrefix
 */
export var internationalPrefixesIdDefault = function (id) {
    return "international-prefixes/".concat(id, "/default");
};
/**
 * Path: /agency-publishers/{id}/resolve
 * POST: No description
 * Request: ResolvePublisherRequest
 * Response: void
 */
export var agencyPublishersIdResolve = function (id) {
    return "agency-publishers/".concat(id, "/resolve");
};
/**
 * Path: /products/{id}/accessibility
 * PATCH: No description
 * Request: ProductAccessibilityRequest
 * Response: void
 */
export var productsIdAccessibility = function (id) {
    return "products/".concat(id, "/accessibility");
};
/**
 * Path: /thema-import/status/{importId}
 * GET: No description
 * Response: ImportProgressDto
 */
export var themaImportStatusImportid = function (importId) {
    return "thema-import/status/".concat(importId);
};
/**
 * Path: /storage/content/{filename}
 * GET: No description
 * Response: StreamingResponseBody
 */
export var storageContentFilename = function (filename) {
    return "storage/content/".concat(filename);
};
/**
 * Path: /reports/jobs/{jobId}
 * GET: Status of an asynchronously generated report
 * Response: ReportJob
 */
export var reportsJobsJobid = function (jobId) {
    return "reports/jobs/".concat(jobId);
};
/**
 * Path: /reports/jobs/{jobId}/file
 * GET: Download the file of a finished report job
 * Response: string
 */
export var reportsJobsJobidFile = function (jobId) {
    return "reports/jobs/".concat(jobId, "/file");
};
/**
 * Path: /product-numbers/{productNumberId}
 * GET: No description
 * Response: ProductNumber
 */
export var productNumbersProductnumberid = function (productNumberId) { return "product-numbers/".concat(productNumberId); };
/**
 * Path: /product-numbers/by-title/{titleId}
 * GET: No description
 * Response: ProductNumberCollectionResponse
 */
export var productNumbersByTitleTitleid = function (titleId) {
    return "product-numbers/by-title/".concat(titleId);
};
/**
 * Path: /product-numbers/assign/{productId}/by-product-id
 * GET: No description
 * Response: ProductNumberAssignResponse
 */
export var productNumbersAssignProductidByProductId = function (productId) { return "product-numbers/assign/".concat(productId, "/by-product-id"); };
/**
 * Path: /international-prefixes/{id}
 * GET: No description
 * Response: InternationalPrefix
 * DELETE: No description
 * Response: void
 */
export var internationalPrefixesId = function (id) {
    return "international-prefixes/".concat(id);
};
/**
 * Path: /collections/{issn}/by-issn
 * GET: No description
 * Response: Collection
 */
export var collectionsIssnByIssn = function (issn) {
    return "collections/".concat(issn, "/by-issn");
};
/**
 * Path: /authority-import/status/{importId}
 * GET: No description
 * Response: ImportProgressDto
 */
export var authorityImportStatusImportid = function (importId) {
    return "authority-import/status/".concat(importId);
};
/**
 * Path: /agency/public-view/titles/{id}
 * GET: No description
 * Response: TitleDetailDto
 */
export var agencyPublicViewTitlesId = function (id) {
    return "agency/public-view/titles/".concat(id);
};
/**
 * Path: /agency/public-view/titles/{id}/recommendations
 * GET: No description
 * Response: TitleRecommendationsDto
 */
export var agencyPublicViewTitlesIdRecommendations = function (id) {
    return "agency/public-view/titles/".concat(id, "/recommendations");
};
/**
 * Path: /agency/public-view/publishers/{id}
 * GET: No description
 * Response: PublisherDetailDto
 */
export var agencyPublicViewPublishersId = function (id) {
    return "agency/public-view/publishers/".concat(id);
};
/**
 * Path: /agency/public-view/authors/{id}
 * GET: No description
 * Response: AuthorDetailDto
 */
export var agencyPublicViewAuthorsId = function (id) {
    return "agency/public-view/authors/".concat(id);
};
/**
 * Path: /agency-publishers/{id}
 * GET: No description
 * Response: Publisher
 */
export var agencyPublishersId = function (id) {
    return "agency-publishers/".concat(id);
};
/**
 * Path: /agency-publishers/{id}/prefix-history
 * GET: No description
 * Response: PublisherPrefixHistoryCollectionResponse
 */
export var agencyPublishersIdPrefixHistory = function (id) {
    return "agency-publishers/".concat(id, "/prefix-history");
};
/**
 * Path: /agency-publishers/{id}/generic-product-numbers
 * GET: No description
 * Response: GenericProductNumberCollectionResponse
 */
export var agencyPublishersIdGenericProductNumbers = function (id) {
    return "agency-publishers/".concat(id, "/generic-product-numbers");
};
/**
 * Path: /agency-publishers/by-source-id/{sourceId}
 * GET: No description
 * Response: Publisher
 */
export var agencyPublishersBySourceIdSourceid = function (sourceId) {
    return "agency-publishers/by-source-id/".concat(sourceId);
};
/**
 * Path: /agency-publishers/by-source-id/{sourceId}/prefix-history
 * GET: No description
 * Response: PublisherPrefixHistoryCollectionResponse
 */
export var agencyPublishersBySourceIdSourceidPrefixHistory = function (sourceId) { return "agency-publishers/by-source-id/".concat(sourceId, "/prefix-history"); };
/**
 * Path: /agency-prefixes/{id}
 * GET: No description
 * Response: AgencyPrefix
 * DELETE: No description
 * Response: void
 */
export var agencyPrefixesId = function (id) {
    return "agency-prefixes/".concat(id);
};
/**
 * Path: /agency-prefixes/{id}/valid-magnitudes
 * GET: No description
 * Response: ValidMagnitudeRangeResponse
 */
export var agencyPrefixesIdValidMagnitudes = function (id) {
    return "agency-prefixes/".concat(id, "/valid-magnitudes");
};
/**
 * Path: /_/tenant/{operationId}
 * GET: Does tenant id already exist
 * Response: string
 * DELETE: drop tenant id
 * Response: void
 */
export var tenantOperationid = function (operationId) {
    return "_/tenant/".concat(operationId);
};
